import { Component, Input, AfterViewInit } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { DaoService } from '../../../../core/dao/dao.service';
import { IMenuItem } from '../../../../core/models/plugin.model';

@Component({
  selector: 'app-admin-user-task-detail',
  templateUrl: './admin.user.task.detail.html',
  styleUrls: ['./admin.user.task.detail.scss']
})
export class AdminUserTaskDetailGridComponent implements AfterViewInit {
  @Input() data!: any;
  dataSource!: DataSource;
  columns: any[] = [];
  constructor(private dao: DaoService) {
    this.initGrid();
  }

  initGrid() {

    this.columns = [
      {
        dataField: "pluginId",
      },
      {
        dataField: "sourceUrl",
        width: 250
      },
      {
        dataField: "destinationUrl",
        width: 250
      },
      {
        dataField: "originalFileName",
      },
      {
        dataField: "fileSize",
      },
      {
        dataField: "sampleRate",
      },
      {
        dataField: "numSamples",
      },
      {
        dataField: "gainMatchCoefficient",
      },
      {
        dataField: "status",
      },
      {
        dataField: "errorMessage"
      },
      {
        caption: "Menu Items",
        menuItems: "menuItems",
        cellTemplate: function (container: any, options: any) {
          let html = "";
          let values = options.key.menuItems
          for (var i = 0; i < values.length; i++) {
            let element = values[i];
            html += "ITEM: " + element.item + ", MENU ID: " + element.menuId + ", ";
          }
          container.innerHTML = html;
        },
      }
    ]
  }

  ngAfterViewInit() {
    this.dataSource = new DataSource({
      store: new ArrayStore({
        data: this.data.row.data.taskBlocks
      })
    });
  }
}
